export const LANGUAGE = {
  TH: "th",
  EN: "en",
};
